import React from 'react';
import { Navigate } from 'react-router-dom';
import MapEditor from './views/MapEditor';
const routes: any[] = [
  {
    path: '/',
    children: [
      { index: true, element: <Navigate to="mapeditor" /> },
      { path: 'mapeditor', element: <MapEditor /> },
    ],
  },
  {
    path: '/app',
    children: [
      { index: true, element: <Navigate to="mapeditor" /> },
      { path: 'mapeditor', element: <MapEditor /> },
    ],
  },
];

export default routes;
